import request from 'sb-request'
import { reducers, getState } from 'redux/core'
import { modifyTokens } from 'common/helpers/modifiers/modifyResponse'


const get = (tokenName) => {
  const { models: { requestTokens } } = getState()

  return requestTokens[tokenName]
}

const { update, set } = reducers.models.requestTokens

/**
 * Fetches tokens
 *
 * @param {Promise} [awaitFor]
 */
const fetch = (awaitFor) =>
  request.post('graphql?name=tokens', {
    body: {
      query: `{
        tokens {
          name
          value
        }
      }`,
    },
    withErrorModal: false,
    modifyResult: ({ tokens }) => modifyTokens(tokens),
  }).then(
    (tokens) => {
      if (!awaitFor) {
        awaitFor = new Promise((resolve) => resolve())
      }

      awaitFor.then(() => {
        update(tokens)
      })

      return tokens
    }
  )


export default {
  get,
  update,
  set,
  fetch,
}
